import { combineReducers } from 'redux';
import * as InspectionActionTypes from '../inspection/inspection.actionTypes';
import keys from 'lodash/keys';
import merge from 'lodash/merge';
import omit from 'lodash/omit';

const allIds = (state = [], action) => {
  switch (action.type) {
    case InspectionActionTypes.READ_INSPECTION_TYPES_SUCCESS:
      return action.response.result;
    default:
      return state;
  }
};


const byId = (state = {}, action) => {
  if (
    action.response &&
    action.response.entities &&
    action.response.entities.inspectionType
  ) {
    if (action.response.method && action.response.method === 'DELETE') {
      return omit(state, keys(action.response.entities.inspectionType));
    }
    return merge({}, state, action.response.entities.inspectionType);
  }
  return state;
};
/*
const byBrand = (state = {}, action) => {
  if (
    action.response &&
    action.response.entities &&
    action.response.entities.inspectionType
  ) {
    if (action.response.method && action.response.method === 'DELETE') {
      return omit(state, keys(action.response.entities.availableBrand));
    }
    return merge({}, state, action.response.entities.availableBrand);
  }
  return state;
};

const byType = (state = {}, action) => {
  if (
    action.response &&
    action.response.entities &&
    action.response.entities.inspectionType
  ) {
    if (action.response.method && action.response.method === 'DELETE') {
      return omit(state, keys(action.response.entities.availableType));
    }
    return merge({}, state, action.response.entities.availableType);
  }
  return state;
};

const byInspection = (state = {}, action) => {
  if (
    action.response &&
    action.response.entities &&
    action.response.entities.inspectionType
  ) {
    if (action.response.method && action.response.method === 'DELETE') {
      return omit(state, keys(action.response.entities.availableInspection));
    }
    return merge({}, state, action.response.entities.availableInspection);
  }
  return state;
};
*/
const reducer = combineReducers({
  allIds,
  byId,
  //byBrand,
  //byType,
  //byInspection,
  //isFetching,
  //errorMessage,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/inspectionType/inspectionType.reducer.js